import iconTrash from "../../assets/icon-trash.svg";

interface HeadingBlockProps {
  value: string;
  onChange: (value: string) => void;
  onDelete: () => void;
}

export function HeadingBlock({ value, onChange, onDelete }: HeadingBlockProps) {
  return (
    <div className="flex items-start gap-2">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Heading 2"
        className="flex-1 text-[19px] font-semibold text-text-primary placeholder:text-text-tertiary bg-transparent border-none outline-none leading-[1.2]"
      />
      <button type="button" onClick={onDelete} className="p-1 shrink-0 hover:opacity-70">
        <img src={iconTrash} alt="Delete block" width={20} height={20} />
      </button>
    </div>
  );
}
